// removed by extract-text-webpack-plugin
module.exports = {"card-wrapper":"DeveloperAppCard__card-wrapper___x2CLn","card":"DeveloperAppCard__card___3OgG3","single":"DeveloperAppCard__single___1PBvV","dark":"DeveloperAppCard__dark___2DYjw","details":"DeveloperAppCard__details___2BrDV","category":"DeveloperAppCard__category___1OFD4 _typography__text-ellipsis___tUHkx","title":"DeveloperAppCard__title___SyHR5 _typography__h6___1u75q _typography__headers___eO5yD _typography__text-ellipsis___tUHkx","meta-info":"DeveloperAppCard__meta-info___1vT2D","desc":"DeveloperAppCard__desc___1rC-q","link":"DeveloperAppCard__link___2iLkv"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/AppCard/DeveloperAppCard.scss
// module id = 526
// module chunks = 0